import { render, staticRenderFns } from "./PenindakanAppUM.vue?vue&type=template&id=370fd645&scoped=true"
import script from "./PenindakanAppUM.vue?vue&type=script&lang=js"
export * from "./PenindakanAppUM.vue?vue&type=script&lang=js"
import style0 from "./PenindakanAppUM.vue?vue&type=style&index=0&id=370fd645&prod&scoped=true&lang=css"
import style1 from "./PenindakanAppUM.vue?vue&type=style&index=1&id=370fd645&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370fd645",
  null
  
)

export default component.exports